import { api } from '@/core/api/';
const apiUrl = 'api/referrals';

export default {
  getAcademicyears() {
    return api.get(`${apiUrl}/academicyears`);
  },
  getStatuses() {
    return api.get(`${apiUrl}/servicestatus`);
  },
  getEquipmentStatuses() {
    return api.get(`${apiUrl}/equipment/statuses`);
  },
  getReferralTypes() {
    return api.get(`${apiUrl}/referraltypes`);
  },
  getClassificationServiceStatus() {
    return api.get(`${apiUrl}/classificastionservicestatus`);
  },
  getCaats() {
    return api.get(`${apiUrl}/caats`);
  },
};
